import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebaseConfig/firebase";
import { addDoc, collection } from "firebase/firestore";
import { Col, Container, Row } from "react-bootstrap";
import { ciclos, paths } from "../../data/dataSourese";
import { Login } from "../Login/Login";
import { DataContex } from "../../context/DataContext";
import { MaterialABMForm } from "../MaterialABMForm/MaterialABMForm";

export const MaterialCreate = () => {
  const { userIsLogin } = useContext(DataContex);
  const [description, setDescription] = useState("");
  const [descargas, setDescargas] = useState(0);
  const [niveles, setNiveles] = useState([]);
  const [obraIDs, setObraIDs] = useState([]);
  const [tipo, setTipo] = useState("");
  const [link, setLink] = useState("");
  const [title, setTitle] = useState("");
  const [nivelAcceso, setNivelAcceso] = useState(0);

  const navigate = useNavigate();
  const recursosCollection = collection(db, "recursos");
  const listaDeRecursos = async (e) => {
    e.preventDefault();

    try {
      await addDoc(recursosCollection, {
        description,
        descargas,
        niveles: niveles,
        obraIDs,
        tipo,
        link,
        title,
        nivelAcceso,
      });
      navigate(`/${paths.abm}`);
    } catch (error) {
      console.error("Error al agregar documento: ", error);
      navigate(`/${paths.abm}`);
    }
  };

  const handleCheckboxChange = (e) => {
    const nivelSeleccionado = e.target.id; // Obtiene el id del checkbox seleccionado

    if (e.target.checked) {
      setNiveles((prevNiveles) => [...prevNiveles, nivelSeleccionado]); // Agrega el nivel seleccionado al array
    } else {
      setNiveles((prevNiveles) =>
        prevNiveles.filter((nivel) => nivel !== nivelSeleccionado)
      ); // Elimina el nivel seleccionado del array
    }
  };

  const handleObraCheckboxChange = (e) => {
    const obraSeleccionada = e.target.id; // ID de la obra correspondiente al checkbox

    if (e.target.checked) {
      setObraIDs((prevObraIDs) => [...prevObraIDs, obraSeleccionada]);
    } else {
      setObraIDs((prevObraIDs) =>
        prevObraIDs.filter((obraID) => obraID !== obraSeleccionada)
      );
    }
  };

  return (
    <Row>
      <Container fluid>
        <Container>
          <h1>MaterialCreate</h1>
          {userIsLogin ? (
            <>
              <MaterialABMForm
                onSubmit={listaDeRecursos}
                submitText={"Crear material"}
                description={description}
                setDescription={setDescription}
                descargas={descargas}
                setDescargas={setDescargas}
                ciclos={ciclos}
                niveles={niveles}
                handleCheckboxChange={handleCheckboxChange}
                obraIDs={obraIDs}
                handleObraCheckboxChange={handleObraCheckboxChange}
                tipo={tipo}
                setTipo={setTipo}
                link={link}
                setLink={setLink}
                title={title}
                setTitle={setTitle}
                nivelAcceso={nivelAcceso}
                setNivelAcceso={setNivelAcceso}
              />
            </>
          ) : (
            <Col className="mb-5 mt-5">
              <Login />
            </Col>
          )}
        </Container>
      </Container>
    </Row>
  );
};

export {};
